<template>
  <div class="uiwu">
      <div class="uiwu-head uiwu-box uiwu-flex" :style="{'width':widthNum + 'px'}">
          <router-link to="/" tag="a" >
              <img src="../../assets/home/pc/logo.png" alt="logo">
          </router-link>
          <nav class="uiwu-flex">
                <router-link :class="menuIndex == index ? 'active' : ''" v-for="(item,index) in menulist" :key="index" :to="item.path" tag="a" >
                    {{item.name}}
                </router-link>
          </nav>
      </div>
  </div>
</template>

<script>
export default {
    props:{
        menuIndex:{
            default:0,
            type:Number
        },
        widthNum:{
            default:1000,
            type:Number
        }
    },
    data(){
        return {
            menulist:[{
                name:'首页',
                path:'/'
            },{
                name:'关于',
                path:'/about'
            },{
                name:'新闻',
                path:'/news'
            },{
                name:'招聘',
                path:'/recruit'
            }]
        }
    },
    created(){

    },
    methods:{

    }
}
</script>

<style lang="scss">
    .uiwu-head{
        height: 90px;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
         @media screen and(max-width:1024px) {
              padding: 0 30px;
              width: 100% !important;
          }
         @media screen and (min-width:320px) and (max-width:767px) {
             height: 1.2rem;
             padding: 0 .4rem;
             width: 100% !important;
             img{
                 width: 2.16rem;
             }
         }
         
        nav{
            align-items: center;
            a{
                margin-left: 60px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666;
                &.active{
                    color: #13A854;
                }
                &:hover{
                    color: #13A854;
                }
                
            }
            @media screen and (min-width:375px) and (max-width:767px) {
                height: 100%;
                a{
                    font-size: .32rem;
                    margin-left: .8rem;
                }
            }
            @media screen and (min-width:320px) and (max-width:374px) {
                height: 100%;
                a{
                    font-size: .32rem;
                    margin-left: .7rem;
                }
            }
        }
    }
</style>